import { Component, OnInit } from '@angular/core';
import { ApiDataService } from '../api-data.service';

@Component({
  selector: 'zest-faqs-card',
  templateUrl: './faqs-card.component.html',
  styleUrls: ['./faqs-card.component.scss']
})
export class FaqsCardComponent implements OnInit {

  faqs: any;

  constructor(
    private apiDataService: ApiDataService
  ) { }

  ngOnInit() {
    this.apiDataService.getFaqs().subscribe(response => {
      this.faqs = response['approve'];
      this.faqs = this.faqs.filter(faq => (!faq.category || (faq.category && faq.category.length > 0 && faq.category.toLowerCase() !== 'nach')));
    });
  }

}
